<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-5>
          <v-flex xs12>
            <span class="heading">Daily Rescue Report</span>
          </v-flex>

          <!-- Filters -->
          <v-flex xs12 pt-6>
            <v-layout wrap>
                    <v-flex xs12 sm6 md3 lg3 pl-md-2 pl-lg-2 pl-sm-2>
                      <v-text-field
                        v-model="fromDateTime"
                        label="From Date & Time"
                        type="datetime-local"
                        :max="blockDateTime"
                        outlined
                        class="itemform"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3 lg3 pl-md-2 pl-lg-2 pl-sm-2>
                      <v-text-field
                        v-model="toDateTime"
                        label="To Date & Time"
                        type="datetime-local"
                        :max="blockDateTime"
                        outlined
                        class="itemform"
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 md2 lg2 pl-md-2 pl-lg-2 pl-sm-2>
                      <v-btn
                        color="#fdac53"
                        class="downlink"
                        target="_blank"
                        @click="getPDF()"
                        block
                      >
                        <span
                          style="
                            font-size: 10px;
                            font-family: poppinssemibold;
                            color: black;
                          "
                        >
                          <v-icon color="black" small
                            >mdi-file-pdf-box</v-icon
                          >PDF</span
                        >
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm3 md2 lg2 pl-md-2 pl-lg-2 pl-sm-2 pt-2 pt-sm-0>
                      <v-btn
                        color="#4caf50"
                        class="downlink"
                        target="_blank"
                        @click="getExcel()"
                        block
                      >
                        <span
                          style="
                            font-size: 10px;
                            font-family: poppinssemibold;
                            color: white;
                          "
                        >
                          <v-icon color="white" small
                            >mdi-file-excel</v-icon
                          >EXCEL</span
                        >
                      </v-btn>
                    </v-flex>

              <v-flex xs12 sm6 md2 lg2 pl-md-2 pl-lg-2 pl-sm-2 pt-2 pt-sm-0>
                <v-btn
                  color="primary"
                  block
                  :loading="tableLoading"
                  @click="fetchReports(true); fetchAnalytics()"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  Load Reports
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- Analytics -->
          <v-flex xs12 pt-6 v-if="!isDeoc">
             <v-card elevation="2" class="pa-4">
                <v-layout wrap align-center justify-space-between class="mb-0" @click="showAnalytics = !showAnalytics" style="cursor: pointer">
                    <v-flex>
                        <span class="subheading">Division Wise Analytics</span>
                        <v-icon right>{{ showAnalytics ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-flex>
                    <v-flex shrink>
                         <v-chip color="primary" outlined small v-if="!analyticsLoading && analytics.length">
                            Total Divisions: {{ analytics.length }}
                         </v-chip>
                    </v-flex>
                </v-layout>
                
                <v-expand-transition>
                  <div v-show="showAnalytics">
                    <v-layout wrap justify-center v-if="analyticsLoading" class="py-5">
                       <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-layout>
                    
                    <div v-else-if="analytics && analytics.length > 0" style="max-height: 400px; overflow-y: auto; overflow-x: hidden;" class="custom-scroll mt-4">
                       <v-layout wrap>
                           <v-flex xs12 sm6 md4 lg3 v-for="(item, i) in analytics" :key="i" class="pa-2">
                              <v-card outlined class="pa-3 d-flex justify-space-between align-center rounded-lg" 
                                      :class="{'elevation-2 white': item.totalReports > 0, 'grey lighten-5': item.totalReports === 0}"
                                      :style="item.totalReports > 0 ? 'border-left: 4px solid #fdac53' : 'border-left: 4px solid #ddd'">
                                 <div class="caption font-weight-bold grey--text text--darken-3 text-truncate pr-2" :title="item.divisionName">
                                   {{ item.divisionName }}
                                 </div>
                                 <div class="headline font-weight-bold" :class="item.totalReports > 0 ? 'primary--text' : 'grey--text'">
                                   {{ item.totalReports }}
                                 </div>
                              </v-card>
                           </v-flex>
                       </v-layout>
                    </div>
                    
                    <div v-else class="text-center grey--text py-5">
                       No analytics data available
                    </div>
                  </div>
                </v-expand-transition>
             </v-card>
          </v-flex>

          <!-- Table -->
          <v-flex xs12 pt-6>
            <v-card elevation="2">
              <v-card-title class="pb-0">
                <span class="subheading">Daily Reports</span>
                <v-spacer></v-spacer>
                <!-- <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                  style="max-width: 280px"
                ></v-text-field> -->
              </v-card-title>

              <v-data-table
                :headers="headers"
                :items="reports"
                :server-items-length="total"
                :options.sync="options"
                :loading="tableLoading"
                :footer-props="{
                  'items-per-page-options': [5, 10, 15, 25, 50],
                  showFirstLastPage: true
                }"
                :search="search"
                loading-text="Loading reports... Please wait"
                no-data-text="No reports found for the selected date range"
                class="elevation-0"
              >
                <template v-slot:item.incidentDate="{ item }">
                  {{ formatDate(item.incidentDate) }}
                </template>
                <template v-slot:item.incidentTime="{ item }">
                  {{ formatTime(item.incidentTime) }}
                </template>

                <template v-slot:item.animal="{ item }">
                  {{ item.animalId ? item.animalId.name : '—' }}
                </template>

                <template v-slot:item.threat="{ item }">
                  {{ item.userthreatlevel || '—' }}
                </template>

                <template v-slot:item.damage="{ item }">
                  {{ item.anyDamage || '—' }}
                </template>

                <template v-slot:item.created="{ item }">
                  {{ formatDateTime(item.create_date) }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="teal"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="viewReport(item._id)"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>View Report</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="canActionReport(item)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="primary"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="editReport(item)"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit Report</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="canActionReport(item)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="error"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="confirmDelete(item)"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete Report</span>
                  </v-tooltip>
                </template>

                <template v-slot:item.attachments="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="indigo"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="openUploadDialog(item)"
                      >
                        <v-icon small>mdi-paperclip</v-icon>
                      </v-btn>
                    </template>
                    <span>Upload Attachments</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline red--text">Confirm Delete</v-card-title>
        <v-card-text>
          Are you sure you want to delete this report? This action cannot be undone.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" text @click="deleteReport">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- View Report Dialog -->
    <v-dialog v-model="viewDialog" max-width="960" scrollable>
      <v-card>
        <v-card-title class="primary white--text headline">
          Daily Human-Wildlife Conflict Report
          <v-spacer></v-spacer>
          <v-btn icon dark @click="viewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Loading state -->
        <v-card-text v-if="viewLoading" class="text-center py-10">
          <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
          <div class="mt-4 grey--text">Loading report details...</div>
        </v-card-text>

        <v-card-text v-else-if="viewedReport" class="pt-6 pb-8">

          <!-- 1. BASIC INFORMATION -->
          <div class="mb-6">
            <h2 class="primary--text mb-4">1. Basic Information</h2>
            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <strong>Location Name:</strong><br>{{ viewedReport.locationname || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>District:</strong><br>{{ viewedReport.district || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Local Body Type:</strong><br>{{ viewedReport.localBodyType || 'Panchayat' }}
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="viewedReport.localBodyType === 'Municipality'">
                <strong>Municipality:</strong><br>{{ viewedReport.municipality || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4" v-else-if="viewedReport.localBodyType === 'Corporation'">
                <strong>Corporation:</strong><br>{{ viewedReport.corporation || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4" v-else>
                <strong>Panchayat:</strong><br>{{ viewedReport.panchayat || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>LA Constituency:</strong><br>{{ viewedReport.assembly || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Parliament Constituency:</strong><br>{{ viewedReport.constituency || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Division:</strong><br>{{ viewedReport.division || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Range:</strong><br>{{ viewedReport.range || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Section / Station:</strong><br>{{ viewedReport.section_station || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Village:</strong><br>{{ viewedReport.village || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Taluk:</strong><br>{{ viewedReport.taluk || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Coordinates:</strong><br>
                {{ viewedReport.lat || '—' }}, {{ viewedReport.lon || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Incident Date &amp; Time:</strong><br>
                {{ formatDate(viewedReport.incidentDate) }}
                &nbsp;{{ formatTime(viewedReport.incidentTime) }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Animal Involved:</strong><br>
                {{ viewedReport.animalId ? viewedReport.animalId.name : '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Number of Animals:</strong><br>{{ viewedReport.animalCount || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Threat Level:</strong><br>{{ viewedReport.userthreatlevel || '—' }}
              </v-col>
              <v-col cols="12" class="mt-3">
                <strong>Any Damage Reported?</strong><br>
                <span :class="viewedReport.anyDamage === 'Yes' ? 'success--text' : 'grey--text'">
                  {{ viewedReport.anyDamage || '—' }}
                </span>
              </v-col>
              <v-col cols="12" v-if="viewedReport.conflictTypeId && viewedReport.conflictTypeId.length">
                <strong>Conflict Types:</strong>
                <div class="ml-2 mt-1">
                  <v-chip
                    v-for="id in viewedReport.conflictTypeId"
                    :key="id"
                    small class="ma-1" color="primary" text-color="white"
                  >{{ id.name }}</v-chip>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- 2. DAMAGE DETAILS -->
          <div class="mb-6" v-if="viewedReport.anyDamage === 'Yes' || viewedReport.anyDamage === 'Unverified incident'">
            <h2 class="primary--text mb-4">2. Damage / Impact Details</h2>

            <!-- Crop Damage -->
            <div v-if="viewedReport.cropDamageDetails && viewedReport.cropDamageDetails.length">
              <h3 class="mb-3">Crop Damage</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead><tr><th>Crop ID</th><th>Quantity</th><th>Unit</th></tr></thead>
                  <tbody>
                    <tr v-for="(item, i) in viewedReport.cropDamageDetails" :key="'vc-'+i">
                      <td>{{ item.cropId.name || '—' }}</td>
                      <td>{{ item.count || '—' }}</td>
                      <td>{{ item.unit || '—' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Property Damage -->
            <div v-if="viewedReport.propertyDamageDetails && viewedReport.propertyDamageDetails.length" class="mt-6">
              <h3 class="mb-3">Property Damage</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead><tr><th>Type of Property</th><th>Details</th></tr></thead>
                  <tbody>
                    <tr v-for="(item, i) in viewedReport.propertyDamageDetails" :key="'vp-'+i">
                      <td>{{ item.propertyType || '—' }}</td>
                      <td>{{ item.damageDetail || '—' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Human Injury -->
            <div v-if="viewedReport.humanInjuryDetails && viewedReport.humanInjuryDetails.personDetails && viewedReport.humanInjuryDetails.personDetails.length" class="mt-6">
              <h3 class="mb-3">Human Injury ({{ viewedReport.humanInjuryDetails.injuredNumber }})</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr><th>#</th><th>Name</th><th>Age</th><th>Gender</th><th>Injury Type</th><th>Hospitalized?</th><th>Tribe?</th><th>Location</th></tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, i) in viewedReport.humanInjuryDetails.personDetails" :key="'vhi-'+i">
                      <td>{{ i+1 }}</td>
                      <td>{{ p.name || '—' }}</td>
                      <td>{{ p.age || '—' }}</td>
                      <td>{{ p.gender || '—' }}</td>
                      <td>{{ p.typeOfInjury || '—' }}</td>
                      <td>{{ p.isHospitalized ? 'Yes' : 'No' }}</td>
                      <td>{{ p.tribeStatus || '—' }} {{ p.tribeStatus === 'Yes' ? `(${p.community || '?'})` : '' }}</td>
                      <td>{{ p.forestLocation || '—' }} {{ p.forestLocation === 'Inside' ? `(${p.rfName || '?'})` : '' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Human Death -->
            <div v-if="viewedReport.humanDeathDetails && viewedReport.humanDeathDetails.personDetails && viewedReport.humanDeathDetails.personDetails.length" class="mt-6">
              <h3 class="mb-3 error--text">Human Death ({{ viewedReport.humanDeathDetails.numberOfDied }})</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr><th>#</th><th>Name</th><th>Age</th><th>Gender</th><th>Tribe?</th><th>Location</th></tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, i) in viewedReport.humanDeathDetails.personDetails" :key="'vhd-'+i">
                      <td>{{ i+1 }}</td>
                      <td>{{ p.name || '—' }}</td>
                      <td>{{ p.age || '—' }}</td>
                      <td>{{ p.gender || '—' }}</td>
                      <td>{{ p.tribeStatus || '—' }} {{ p.tribeStatus === 'Yes' ? `(${p.community || '?'})` : '' }}</td>
                      <td>{{ p.forestLocation || '—' }} {{ p.forestLocation === 'Inside' ? `(${p.rfName || '?'})` : '' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Animal Injury -->
            <div v-if="viewedReport.animalInjuryDetails" class="mt-6">
              <h3 class="mb-3">Details Of Animal Injured</h3>
              <v-row dense>
                <v-col cols="12" sm="6">
                  <strong>Number Injured:</strong><br>{{ viewedReport.animalInjuryDetails.injuredNumber || '—' }}
                </v-col>
                <v-col cols="12" sm="6">
                  <strong>Type of Injury:</strong><br>{{ viewedReport.animalInjuryDetails.typeOfInjury || '—' }}
                </v-col>
              </v-row>
            </div>

            <!-- Animal Death -->
            <div v-if="viewedReport.animalDeathDetails && viewedReport.animalDeathDetails.animalDeathDetailsList && viewedReport.animalDeathDetails.animalDeathDetailsList.length" class="mt-6">
              <h3 class="mb-3 error--text">Details Of Animal Died</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead><tr><th>#</th><th>Species</th><th>Gender</th><th>Cause of Death</th></tr></thead>
                  <tbody>
                    <tr v-for="(a, i) in viewedReport.animalDeathDetails.animalDeathDetailsList" :key="'vad-'+i">
                      <td>{{ i+1 }}</td>
                      <td>{{ a.species || '—' }}</td>
                      <td>{{ a.gender || '—' }}</td>
                      <td>{{ a.causeOfDeath || '—' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Livestock -->
            <div v-if="viewedReport.livestockDepredationDetails && viewedReport.livestockDepredationDetails.length" class="mt-6">
              <h3 class="mb-3">Details Of Livestock Depredation</h3>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead><tr><th>#</th><th>Type</th><th>Animal</th><th>Count</th></tr></thead>
                  <tbody>
                    <tr v-for="(item, i) in viewedReport.livestockDepredationDetails" :key="'vl-'+i">
                      <td>{{ i+1 }}</td>
                      <td>{{ item.injuryOrDeath || '—' }}</td>
                      <td>{{ item.typeOfAnimal || '—' }}</td>
                      <td>{{ item.numberOfAnimals || '—' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>

          <!-- 3. ADDITIONAL INFORMATION -->
          <div class="mb-6">
            <h2 class="primary--text mb-4">3. Additional Information</h2>
            <v-row dense>
              <v-col cols="12">
                <strong>Informer Details / Contact:</strong><br>
                <div class="ml-2 mt-1">{{ viewedReport.informerDetails || '—' }}</div>
              </v-col>
              <v-col cols="12" class="mt-3">
                <strong>Incident Summary &amp; Follow-up Action:</strong><br>
                <div class="ml-2 mt-1">{{ viewedReport.userremarks || '—' }}</div>
              </v-col>
              <v-col cols="12" sm="6" class="mt-4">
                <strong>Procedures completed within 24 hours?</strong><br>
                {{ viewedReport.proceduresCompleted24hrs || '—' }}
              </v-col>
              <v-col cols="12" v-if="viewedReport.proceduresCompleted24hrs === 'No'">
                <strong>Reason for delay:</strong><br>
                {{ viewedReport.reason24hrs || '—' }}
              </v-col>
            </v-row>
          </div>

          <!-- 4. RESPONSE TEAM -->
          <div>
            <h2 class="primary--text mb-4">4. Response Team Information</h2>
            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <strong>RRT:</strong><br>{{ viewedReport.rrt || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Response Station:</strong><br>{{ viewedReport.responseStation || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Response Section:</strong><br>{{ viewedReport.responseSection || '—' }}
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <strong>Response Range:</strong><br>{{ viewedReport.responseRange || '—' }}
              </v-col>
              <v-col cols="12">
                <strong>Who Responded:</strong><br>
                <div class="ml-2 mt-1">{{ viewedReport.whoResponded || '—' }}</div>
              </v-col>
              <v-col cols="12">
                <strong>Resources Deployed:</strong><br>
                <div class="ml-2 mt-1">{{ viewedReport.resourceDeployed || '—' }}</div>
              </v-col>
              <v-col cols="12" sm="6">
                <strong>Number of Staff Deployed:</strong><br>
                {{ viewedReport.staffDeployedCount || '—' }}
              </v-col>
            </v-row>
          </div>

          <!-- 5. ATTACHMENTS -->
          <div class="mt-6" v-if="viewedReport.postmortem_report && viewedReport.postmortem_report.length">
            <h2 class="primary--text mb-4">5. Attachments</h2>
            <v-row dense>
              <v-col cols="12">
                <v-chip
                  v-for="(file, index) in viewedReport.postmortem_report"
                  :key="index"
                  class="ma-2"
                  color="primary"
                  outlined
                  @click="viewAttachment(file)"
                >
                  <v-icon left>mdi-paperclip</v-icon>
                  Attachment {{ index + 1 }}
                  <v-icon right small>mdi-open-in-new</v-icon>
                </v-chip>
              </v-col>
            </v-row>
          </div>

        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="justify-end pa-4">
          <v-btn color="grey darken-2" dark @click="viewDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Access Warning Dialog -->
    <v-dialog v-model="accessWarningDialog" max-width="400">
      <v-card>
        <v-card-title class="headline orange--text">Action Restricted</v-card-title>
        <v-card-text class="pt-4">
          {{ warningMsg }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="accessWarningDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Upload Dialog -->
    <v-dialog v-model="uploadDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Upload Attachments</v-card-title>
        <v-card-text>
          <v-file-input
            v-if="!isDocFinalSubmit"
            v-model="selectedFiles"
            color="deep-purple accent-4"
            counter
            label="File input"
            multiple
            placeholder="Select your files"
            prepend-icon="mdi-paperclip"
            outlined
            :show-size="1000"
          >
            <template v-slot:selection="{ index, text }">
              <v-chip
                v-if="index < 2"
                color="deep-purple accent-4"
                dark
                label
                small
              >
                {{ text }}
              </v-chip>
              <span
                v-else-if="index === 2"
                class="overline grey--text text--darken-3 mx-2"
              >
                +{{ selectedFiles.length - 2 }} File(s)
              </span>
            </template>
          </v-file-input>
          
          <v-divider class="my-4" v-if="existingAttachments.length > 0"></v-divider>
          
          <div v-if="existingAttachments.length > 0">
            <div class="subtitle-1 mb-2">Existing Attachments</div>
            <v-list dense>
              <v-list-item v-for="(file, index) in existingAttachments" :key="index">
                <v-list-item-content>
                  <v-list-item-title>Attachment {{ index + 1 }}</v-list-item-title>
                  <v-list-item-subtitle>{{ file }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-layout>
                     <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small @click="viewAttachment(file)" v-bind="attrs" v-on="on">
                          <v-icon color="primary">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>View</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="!isDocFinalSubmit">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small @click="deleteAttachment(file)" v-bind="attrs" v-on="on">
                          <v-icon color="error">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>
                  </v-layout>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="uploadDialog = false">Cancel</v-btn>
          <v-btn 
            v-if="!isDocFinalSubmit" 
            color="primary" 
            text 
            @click="submitUpload" 
            :loading="uploading"
          >
            Upload
          </v-btn>
          <v-btn 
            v-if="!isDocFinalSubmit && existingAttachments.length > 0" 
            color="success" 
            text 
            @click="finalSubmitDialog = true"
          >
            Final Submit
          </v-btn>
          <div v-if="isDocFinalSubmit" class="success--text font-weight-bold px-4">
            Documents have been submitted
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Final Submit Confirmation Dialog -->
    <v-dialog v-model="finalSubmitDialog" max-width="450">
      <v-card>
        <v-card-title class="headline success--text">Confirm Final Submission</v-card-title>
        <v-card-text class="pt-4">
          Are you sure you want to final submit the documents for this case? 
          Please ensure all required attachments are uploaded before proceeding.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="finalSubmitDialog = false">No, Cancel</v-btn>
          <v-btn color="success" text @click="finalSubmit" :loading="finalSubmitting">Yes, Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Floating Unverified Cases Notification -->
    <v-btn
      v-if="isDeoc && unverifiedCount > 0"
      fab
      dark
      fixed
      right
      color="#FF6907"
      style="top: 50%; transform: translateY(-50%); z-index: 5;"
      title="Unverified Cases"
      @click="fetchUnverifiedReports()"
    >
      <v-badge
        color="white"
        overlap
        offset-x="10"
        offset-y="10"
      >
        <template v-slot:badge>
          <span style="color: #FF6907; font-weight: bold">{{ unverifiedCount }}</span>
        </template>
        <v-icon large>mdi-alert-decagram-outline</v-icon>
      </v-badge>
    </v-btn>

    <!-- Unverified Reports Listing Dialog -->
    <v-dialog v-model="unverifiedReportsDialog" max-width="500" scrollable>
      <v-card>
        <v-card-title class="headline orange--text d-flex justify-space-between align-center">
          <span>Unverified Incidents</span>
          <v-btn icon @click="unverifiedReportsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pa-4">
          <div v-if="unverifiedReportsLoading" class="text-center py-5">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <div class="mt-2 grey--text">Fetching details...</div>
          </div>
          <div v-else-if="unverifiedReports.length > 0">
            <v-alert
              v-for="report in unverifiedReports"
              :key="report._id"
              border="left"
              colored-border
              color="orange"
              elevation="1"
              class="mb-3"
            >
              <div class="subtitle-2 font-weight-bold">
                Unverified incident reported by {{ report.addedby ? report.addedby.name : 'Unknown User' }}
              </div>
              <div class="caption grey--text text--darken-2">
                Reported on: {{ formatDateTime(report.create_date) }}
              </div>
              <v-btn
                text
                small
                color="primary"
                class="mt-2 pa-0"
                @click="viewReport(report._id); unverifiedReportsDialog = false"
              >
                View Details
              </v-btn>
            </v-alert>
          </div>
          <div v-else class="text-center py-5 grey--text">
            No unverified incidents found.
          </div>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="unverifiedReportsDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    const now = new Date();
    const currentHour = now.getHours();
    
    let fromDateObj = new Date();
    let toDateObj = new Date();
    
    if (currentHour < 10) {
      fromDateObj.setDate(now.getDate() - 1);
      toDateObj.setDate(now.getDate());
    } else {
      fromDateObj.setDate(now.getDate());
      toDateObj.setDate(now.getDate() + 1);
    }
    
    const fromDateStr = fromDateObj.toISOString().substr(0, 10);
    const toDateStr = toDateObj.toISOString().substr(0, 10);
    
    const fromDateTime = `${fromDateStr}T10:00`;
    const toDateTime = `${toDateStr}T09:59`;

    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,

      fromDateTime: fromDateTime,
      toDateTime: toDateTime,
      blockDateTime: toDateTime,

      // Table & Pagination
      reports: [],
      analytics: [],
      analyticsLoading: false,
      showAnalytics: false,
      unverifiedCount: 0,
      unverifiedReports: [],
      unverifiedReportsDialog: false,
      unverifiedReportsLoading: false,
      total: 0,
      tableLoading: false,
      search: "",
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["create_date"],
        sortDesc: [true],
      },

      deleteDialog: false,
      reportToDelete: null,

      // View dialog
      viewDialog: false,
      viewedReport: null,
      viewLoading: false,

      // Access warning dialog
      accessWarningDialog: false,
      warningMsg: "",

      // Upload Dialog
      uploadDialog: false,
      selectedFiles: [],
      existingAttachments: [],
      uploadId: null,
      uploading: false,
      finalSubmitting: false,
      finalSubmitDialog: false,
      isDocFinalSubmit: false,

      headers: [
        { text: "Added By", value: "addedby.name", sortable: false },
        { text: "Location", value: "locationname", sortable: false },
        { text: "Animal", value: "animal", sortable: false },
        { text: "Count", value: "animalCount", sortable: false },
        { text: "Incident Date", value: "incidentDate", sortable: false },
        { text: "Incident Time", value: "incidentTime", sortable: false },
        { text: "Threat Level", value: "threat", sortable: false },
        { text: "Damage", value: "damage", sortable: false },
        { text: "Created At", value: "created", sortable: false },
        { text: "Attachments", value: "attachments", sortable: false, align: "center" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
    };
  },

  watch: {
    fromDateTime(newVal) {
      if (newVal) {
        const d = new Date(newVal);
        d.setDate(d.getDate() + 1);
        const newDateStr = d.toISOString().substr(0, 10);
        this.toDateTime = `${newDateStr}T09:59`;
      }
    },
    options: {
      handler() {
        this.fetchReports();
      },
      deep: true,
    },
  },

  mounted() {
    this.fetchReports();
    this.fetchAnalytics();
    if (this.isDeoc) {
      this.fetchUnverifiedCount();
    }
  },

  computed: {
    isDeoc() {
      return localStorage.getItem('userRole') === 'DEOC';
    },
  },

  methods: {
    // Returns true based on the creation time rule:
    // - If created before 10:00 AM: Edit/Delete allowed until 10:00 AM of the SAME day.
    // - If created after 10:00 AM: Edit/Delete allowed until 10:00 AM of the NEXT day.
    canEditDelete(createDate) {
      if (!createDate) return false;
      const created = new Date(createDate);
      if (isNaN(created.getTime())) return false;

      // Check if created time is before 10:00 AM
      const cutoffSameDay = new Date(
        created.getFullYear(),
        created.getMonth(),
        created.getDate(),
        10, 0, 0, 0
      );

      let deadline;
      if (created < cutoffSameDay) {
        // Created before 10 AM -> deadline is today 10 AM
        deadline = cutoffSameDay;
      } else {
        // Created after 10 AM -> deadline is tomorrow 10 AM
        deadline = new Date(cutoffSameDay);
        deadline.setDate(deadline.getDate() + 1);
      }

      return new Date() < deadline;
    },

    canActionReport(item) {
      if (!this.isDeoc) return false;
      if (item.anyDamage === "Unverified incident" || item.humanDeathDetails.numberOfDied > 0) {
        return !item.isDocFinalSubmit;
      }
      return this.canEditDelete(item.create_date);
    },

    async fetchAnalytics() {
      if (!this.fromDateTime || !this.toDateTime) return;
      this.analyticsLoading = true;
      try {
        const params = {
          fromDate: this.fromDateTime,
          toDate: this.toDateTime,
        };
        const res = await axios.get("/deoc_daily_rescue_report/analytics", {
          headers: { "x-auth-token": localStorage.getItem("token") },
          params
        });
        if (res.data.status) {
          this.analytics = res.data.data || [];
        }
      } catch (err) {
        console.error("Analytics error:", err);
      } finally {
        this.analyticsLoading = false;
      }
    },

    async fetchUnverifiedCount() {
      try {
        const res = await axios.get("/deoc_daily_rescue_report/unverified_reports_notification", {
          headers: { "x-auth-token": localStorage.getItem("token") }
        });
        if (res.data.status && res.data.data) {
          this.unverifiedCount = res.data.data.unverifiedCount || 0;
        }
      } catch (err) {
        console.error("Unverified count error:", err);
      }
    },

    async fetchUnverifiedReports() {
      this.unverifiedReportsDialog = true;
      this.unverifiedReportsLoading = true;
      try {
        const res = await axios.get("/deoc_daily_rescue_report/unverified_reports_pending", {
          headers: { "x-auth-token": localStorage.getItem("token") }
        });
        if (res.data.status) {
          this.unverifiedReports = res.data.data || [];
        }
      } catch (err) {
        console.error("Unverified reports fetch error:", err);
      } finally {
        this.unverifiedReportsLoading = false;
      }
    },

    async fetchReports(resetPage = false) {
      if (resetPage) this.options.page = 1;

      if (!this.fromDateTime || !this.toDateTime) {
        this.msg = "Please select From Date and To Date";
        this.showSnackBar = true;
        return;
      }

      this.tableLoading = true;
      this.appLoading = true;

      try {
        const params = {
          fromDate: this.fromDateTime,
          toDate: this.toDateTime,
          page: this.options.page,
          limit: this.options.itemsPerPage,
        };

        if (this.options.sortBy && this.options.sortBy.length) {
          params.sortBy = this.options.sortBy[0];
          params.sortOrder = this.options.sortDesc[0] ? "desc" : "asc";
        }

        const response = await axios.get("/deoc_daily_rescue_report/list", {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          params,
        });

        if (response.data.status === true) {
          this.reports = response.data.data || [];
          this.total = response.data.total || 0;
        } else {
          this.msg = response.data.msg || "Failed to load reports";
          this.showSnackBar = true;
        }
      } catch (err) {
        console.error("List fetch error:", err);
        this.msg = "Error loading reports";
        this.showSnackBar = true;
      } finally {
        this.tableLoading = false;
        this.appLoading = false;
      }
    },

    async viewReport(id) {
      this.viewedReport = null;
      this.viewDialog = true;
      this.viewLoading = true;

      try {
        const res = await axios.get(`/deoc_daily_rescue_report/view/${id}`, {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        });

        if (res.data.status === true && res.data.data) {
          this.viewedReport = res.data.data;
        } else {
          this.msg = res.data.msg || "Failed to load report details";
          this.showSnackBar = true;
          this.viewDialog = false;
        }
      } catch (err) {
        console.error("View error:", err);
        this.msg = "Error loading report details";
        this.showSnackBar = true;
        this.viewDialog = false;
      } finally {
        this.viewLoading = false;
      }
    },

    editReport(item) {
      // Re-check at click time — deadline may have passed while page was open
      if (!this.isDeoc) {
        this.warningMsg = "You do not have permission to edit reports.";
        this.accessWarningDialog = true;
        return;
      }

      const id = item._id;
      const createDate = item.create_date;

      if (item.anyDamage === "Unverified incident" || item.humanDeathDetails.numberOfDied > 0) {
        if (item.isDocFinalSubmit) {
          this.warningMsg = "This unverified incident has been final submitted and can no longer be edited.";
          this.accessWarningDialog = true;
          return;
        }
      } else {
        if (!this.canEditDelete(createDate)) {
          this.warningMsg = "Edit window has closed. Reports created before 10:00 AM can be edited until 10:00 AM today. Reports created after 10:00 AM can be edited until 10:00 AM tomorrow.";
          this.accessWarningDialog = true;
          return;
        }
      }

      this.$router.push({
        path: `/officers/daily-reporting-rescue/${id}`
      });
    },

    confirmDelete(item) {
      // Re-check at click time — deadline may have passed while page was open
      if (!this.isDeoc) {
        this.warningMsg = "You do not have permission to delete reports.";
        this.accessWarningDialog = true;
        return;
      }

      const id = item._id;
      const createDate = item.create_date;

      if (item.anyDamage === "Unverified incident" || item.humanDeathDetails.numberOfDied > 0) {
        if (item.isDocFinalSubmit) {
          this.warningMsg = "This unverified incident has been final submitted and can no longer be deleted.";
          this.accessWarningDialog = true;
          return;
        }
      } else {
        if (!this.canEditDelete(createDate)) {
          this.warningMsg = "Delete window has closed. Reports created before 10:00 AM can be deleted until 10:00 AM today. Reports created after 10:00 AM can be deleted until 10:00 AM tomorrow.";
          this.accessWarningDialog = true;
          return;
        }
      }

      this.reportToDelete = id;
      this.deleteDialog = true;
    },

    async deleteReport() {
      if (!this.reportToDelete) return;
      this.deleteDialog = false;
      this.appLoading = true;

      try {
        const res = await axios.post(
          `/deoc_daily_rescue_report/delete`,
          { id: this.reportToDelete },
          {
            headers: {
              "x-auth-token": localStorage.getItem("token"),
            },
          }
        );

        if (res.data.status === true) {
          this.msg = "Report deleted successfully";
          this.showSnackBar = true;
          this.fetchReports();
        } else {
          this.msg = res.data.msg || "Failed to delete";
          this.showSnackBar = true;
        }
      } catch (err) {
        console.error("Delete error:", err);
        this.msg = "Error deleting report";
        this.showSnackBar = true;
      } finally {
        this.appLoading = false;
        this.reportToDelete = null;
      }
    },

    getPDF() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/daily/rescue_report/pdf-deoc",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        responseType: "blob",
        params: {
          fromDate: this.fromDateTime,
          toDate: this.toDateTime,
        },
      })
        .then((response) => {
          this.appLoading = false;
          const url = URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "DailyReport.pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = "Failed to generate PDF";
          this.showSnackBar = true;
          console.error(err);
        });
    },

    getExcel() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/daily/rescue_report/excel-deoc",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        responseType: "blob",
        params: {
          fromDate: this.fromDateTime,
          toDate: this.toDateTime,
        },
      })
        .then((response) => {
          this.appLoading = false;
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "DailyReport.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = "Failed to generate Excel";
          this.showSnackBar = true;
          console.error(err);
        });
    },

    formatTime(timeStr) {
      if (!timeStr) return '—';
      const [hourStr, minuteStr] = timeStr.split(':');
      const hour = parseInt(hourStr, 10);
      const minute = minuteStr || '00';
      if (isNaN(hour)) return timeStr;
      const period = hour >= 12 ? 'PM' : 'AM';
      const hour12 = hour % 12 || 12;
      return `${String(hour12).padStart(2, '0')}:${minute} ${period}`;
    },

    formatDate(isoString) {
      if (!isoString) return '';
      const date = new Date(isoString);
      if (isNaN(date.getTime())) return '';

      return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replace(/\//g, '-');
    },

    formatDateTime(isoString) {
      if (!isoString) return '—';
      const date = new Date(isoString);
      if (isNaN(date.getTime())) return '—';

      const datePart = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replace(/\//g, '-');

      const timePart = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });

      return `${datePart} ${timePart}`;
    },

    openUploadDialog(item) {
      this.uploadId = item._id;
      this.existingAttachments = item.postmortem_report || [];
      this.isDocFinalSubmit = item.isDocFinalSubmit || false;
      this.selectedFiles = [];
      this.uploadDialog = true;
    },

    viewAttachment(filename) {
      if (!filename) return;
      // unique base url logic if needed, otherwise use global mediaURL
      // The user gave example: https://.../u/filename
      // Assuming mediaURL includes the base path. If not, I might need to prepend.
      // Usually mediaURL is just the base domain/path.
      // Let's try opening mediaURL + filename.
      // Since user said "mediaURL which is already implemented", I'll assume `this.mediaURL` is available.
      // If it's undefined, I'll fallback to a relative path or direct access.
      // However, checking previous files/context, `mediaURL` is often a global mixin.
      // User said "https://l6v8f8f0-3050.inc1.devtunnels.ms/u/1771564747937.pdf"
      // If mediaURL is the base, then:
      const url = this.mediaURL + filename; 
      window.open(url, '_blank');
    },

    async deleteAttachment(filename) {
       if (!confirm("Are you sure you want to delete this attachment?")) return;
       
       this.appLoading = true;
       try {
        const response = await axios.post(
          `/deoc_daily_rescue_report/remove_postmortem_report`,
          {
            id: this.uploadId,
            reportKey: filename
          },
          {
            headers: {
              "x-auth-token": localStorage.getItem("token"),
            },
          }
        );

        if (response.data.status === true) {
          this.msg = "Attachment deleted successfully";
          this.showSnackBar = true;
          
          // Remove from local list
          this.existingAttachments = this.existingAttachments.filter(f => f !== filename);
          
          // Also update the main reports list so if we reopen, it's correct
          const report = this.reports.find(r => r._id === this.uploadId);
          if (report && report.postmortem_report) {
            report.postmortem_report = report.postmortem_report.filter(f => f !== filename);
          }
        } else {
          this.msg = response.data.msg || "Failed to delete attachment";
          this.showSnackBar = true;
        }
       } catch (err) {
         console.error("Delete attachment error:", err);
         this.msg = "Error deleting attachment";
         this.showSnackBar = true;
       } finally {
         this.appLoading = false;
       }
    },

    async submitUpload() {
      if (!this.selectedFiles || this.selectedFiles.length === 0) {
        this.msg = "Please select files to upload";
        this.showSnackBar = true;
        return;
      }

      this.uploading = true;
      const formData = new FormData();
      for (let i = 0; i < this.selectedFiles.length; i++) {
        formData.append("postmortem_report", this.selectedFiles[i]);
      }

      try {
        const response = await axios.post(
          `/deoc_daily_rescue_report/postmortem_report/${this.uploadId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "x-auth-token": localStorage.getItem("token"),
            },
          }
        );

        if (response.data.status === true) {
          this.msg = "Files uploaded successfully";
          this.showSnackBar = true;
          this.selectedFiles = [];
          
          // Close dialog and refresh reports to show updated data
          this.uploadDialog = false;
          this.fetchReports(); 
        } else {
          this.msg = response.data.msg || "Failed to upload files";
          this.showSnackBar = true;
        }
      } catch (err) {
        console.error("Upload error:", err);
        this.msg = "Error uploading files";
        this.showSnackBar = true;
      } finally {
        this.uploading = false;
      }
    },

    async finalSubmit() {
      if (!this.uploadId) return;
      this.finalSubmitting = true;
      try {
        const response = await axios.post(
          `/deoc_daily_rescue_report/document_final_submit/${this.uploadId}`,
          {},
          {
            headers: {
              "x-auth-token": localStorage.getItem("token"),
            },
          }
        );

        if (response.data.status === true) {
          this.msg = response.data.msg || "Final submission successful";
          this.showSnackBar = true;
          this.finalSubmitDialog = false;
          this.uploadDialog = false;
          this.fetchReports();
        } else {
          this.msg = response.data.msg || "Final submission failed";
          this.showSnackBar = true;
        }
      } catch (err) {
        console.error("Final submit error:", err);
        this.msg = "Error during final submission";
        this.showSnackBar = true;
      } finally {
        this.finalSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.heading {
  font-family: poppinsregular;
  font-size: 22px;
  font-weight: 900;
}

.subheading {
  font-family: poppinsregular;
  font-size: 17px;
  font-weight: 600;
}

.itemform >>> .v-input__slot {
  font-family: poppinsregular !important;
}

.custom-scroll::-webkit-scrollbar {
  width: 6px;
}
.custom-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.custom-scroll::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>